export const STATUS = {
  negotiation: { label: "Negociação", cls: "bg-amber-500/10 text-amber-400 border-amber-500/30" },
  fight: { label: "Combate", cls: "bg-rose-500/15 text-rose-400 border-rose-500/40" },
  finished: { label: "Terminada", cls: "bg-slate-800/80 text-slate-300 border-slate-700" },
  cancelled: { label: "Cancelada", cls: "bg-slate-900 text-slate-500 border-slate-800" },
  agreement: { label: "Acordo", cls: "bg-cyan-500/10 text-cyan-400 border-cyan-500/30" },
};

export const RESULT = {
  attacker_win: "Vitória do atacante",
  defender_win: "Vitória do defensor",
  draw: "Empate",
};

export const END_REASON = {
  reported: "Resultado do servidor",
  timeout: "Empate automático (sem resultado)",
  agreement: "Acordo",
  attacker_cancel: "Cancelada pelo atacante",
  admin_cancel: "Cancelada pelo admin",
  season_end: "Fim de temporada",
  no_signal: "Sem sinal do servidor",
  backup_restore: "Cancelada ao restaurar cópia",
};

export const BACKUP_TYPE = {
  auto: { label: "Automática", cls: "border-cyan-500/40 text-cyan-300" },
  manual: { label: "Manual", cls: "border-emerald-500/40 text-emerald-300" },
  pre_restore: { label: "Pré-restauro", cls: "border-amber-500/40 text-amber-300" },
};

export const BACKUP_COLLECTIONS = {
  orgs: "Organizações", zones: "Zonas", recipes: "Receitas", wars: "Guerras",
  seasons: "Temporadas", craft_logs: "Registo de crafts", settings: "Configurações",
};

export const fmtBytes = (n = 0) => (n < 1024 ? `${n} B` : n < 1048576 ? `${(n / 1024).toFixed(1)} KB` : `${(n / 1048576).toFixed(2)} MB`);

export const PAUSE = {
  contested: "PAUSADA – zona contestada",
  no_presence: "PAUSADA – sem presença",
  no_signal: "PAUSADA – sem sinal do servidor",
};

export const fmtDuration = (s) => {
  const d = Math.floor(s / 86400);
  if (d === 0) return fmtClock(s);
  const r = s % 86400;
  const pad = (n) => String(n).padStart(2, "0");
  return `${d}d ${pad(Math.floor(r / 3600))}:${pad(Math.floor((r % 3600) / 60))}:${pad(r % 60)}`;
};

// datas sempre na hora de Lisboa (hora do servidor), seja qual for o fuso do browser
const LISBON = "Europe/Lisbon";
const lisbonParts = (d, opts) => Object.fromEntries(
  new Intl.DateTimeFormat("en-GB", { timeZone: LISBON, hourCycle: "h23", ...opts })
    .formatToParts(new Date(d)).map((p) => [p.type, p.value]),
);
export const fmtDate = (d) => {
  if (!d) return "—";
  const p = lisbonParts(d, { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });
  return `${p.day}/${p.month}/${p.year} ${p.hour}:${p.minute}`;
};
export const fmtTime = (d) => {
  if (!d) return "—";
  const p = lisbonParts(d, { hour: "2-digit", minute: "2-digit" });
  return `${p.hour}:${p.minute}`;
};
export const fmtCoords = (c) => (c ? `${c.x.toFixed(1)}, ${c.y.toFixed(1)}, ${c.z.toFixed(1)}` : "—");

export const fmtClock = (s) => {
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const ss = s % 60;
  const pad = (n) => String(n).padStart(2, "0");
  return h > 0 ? `${h}:${pad(m)}:${pad(ss)}` : `${pad(m)}:${pad(ss)}`;
};
